import { render, staticRenderFns } from "./DeviceSetups.vue?vue&type=template&id=28818bd4&"
import script from "./DeviceSetups.vue?vue&type=script&lang=js&"
export * from "./DeviceSetups.vue?vue&type=script&lang=js&"
import style0 from "./DeviceSetups.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4088215791/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28818bd4')) {
      api.createRecord('28818bd4', component.options)
    } else {
      api.reload('28818bd4', component.options)
    }
    module.hot.accept("./DeviceSetups.vue?vue&type=template&id=28818bd4&", function () {
      api.rerender('28818bd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Devices/Setups/DeviceSetups.vue"
export default component.exports